import { cn } from './cn';

type Props = { variant?: 'top-right' | 'bottom-right' | 'bottom-left'; className?: string };

/** Triangles décoratifs de marque (orange clair et gris-bleu). */
export default function BrandPattern({ variant = 'top-right', className }: Props) {
  const pos = {
    'top-right': 'right-0 top-0',
    'bottom-right': 'bottom-0 right-0 rotate-180',
    'bottom-left': 'bottom-0 left-0 -scale-x-100',
  }[variant];
  return (
    <svg aria-hidden viewBox="0 0 240 240" className={cn('pointer-events-none absolute hidden h-40 w-40 lg:block xl:h-60 xl:w-60', pos, className)}>
      <polygon points="120,0 240,0 240,120" className="fill-brand-tint" />
      <polygon points="0,0 120,0 120,120" className="fill-brand-tint-soft" />
      <polygon points="120,120 240,120 240,240" className="fill-steel-soft" />
      <polygon points="120,120 240,240 120,240" className="fill-brand-tint-soft" />
    </svg>
  );
}
